import { useCallback } from 'react'

import { useEventContext } from 'context/EventContext'

const useHoverEvent = eventProps => {
  const { sendEvent } = useEventContext()

  const handleHoverInteraction = useCallback(() => {
    sendEvent({
      name: eventProps.name || 'engagement_hover',
      engagementDetails: eventProps.engagementDetails,
      engagementDestination: eventProps.engagementDestination,
      engagementComponent: eventProps.engagementComponent,
      ...eventProps,
    })
  }, [sendEvent, eventProps])

  return {
    onMouseEnter: handleHoverInteraction,
    onTouchStart: handleHoverInteraction,
  }
}

export default useHoverEvent
